export default (url: string, branchSlug: string): string => {
    return branchSlug ? '/pobocka-' + branchSlug + url : url
}
